jQuery(document).ready(function () {
    jQuery.ajaxSetup({
        cache: false
    });

    /* https://github.com/aFarkas/lazysizes */
    jQuery.getScript('/files/build/js/lazy/lazysizes.min.js', function (data, textStatus, jqxhr) {
        jQuery.getScript('/files/build/js/lazy/ls.respimg.min.js');
        lazySizes.init();
    });

    jQuery.getScript('/files/build/js/functions.js', function (data, textStatus, jqxhr) {
        jQuery.getScript('/files/build/js/scripts.js');
        jQuery.getScript('/files/build/js/main.js');

        /* icon font */
        loadCSS('/files/build/css/line-awesome.css');

        /* menu desktop / tablet *
        jQuery('#header .mainmenu li.submenu').hover(function () {
                var $item = jQuery(this);
                var menuTimer = $item.data("timeout");
                if (menuTimer) clearTimeout(menuTimer);
                if ($item.parent().hasClass('level_1')) {
                    $item.addClass('open');
                }
            }, function () {
                var $item = jQuery(this);
                if ($item.parent().hasClass('level_1')) {
                    $item.data("timeout", setTimeout($.proxy(function () {
                        jQuery(this).removeClass('open');
                    }, this), 1000));
                }
            }
        );*/

        /* menu touch *
        jQuery('#header .mainmenu li.submenu').on('touchstart', function (e) {
            var $item = jQuery(this);
            if ($item.hasClass('open')) {
                return true;
            } else {
                e.preventDefault();

                var menuTimer = $item.data("timeout");
                if (menuTimer) clearTimeout(menuTimer);
                if ($item.parent().hasClass('level_1')) {
                    $item.addClass('open');

                    $item.data("timeout", setTimeout($.proxy(function () {
                        jQuery(this).removeClass('open');
                    }, this), 5000));
                }

                return false;
            }
        });*/

        /* mobile / sticky navi *
        jQuery('.menu_hamburger').click(function () {
            jQuery('#header .menu, #header .menu_hamburger').toggleClass('open');

            createMobileMenu();
        });*/

        /* colorbox */
        jQuery.getScript('/assets/colorbox/js/colorbox.min.js');

        /* cookiebar should be in default */
        jQuery.getScript('/system/modules/cookiebar/assets/dist/cookiebar.min.js');
    });
});
/*
jQuery(window).scroll(function () {
    if ($(this).scrollTop() > $('#header').height()) {
        if (!$('#header').hasClass('sticky')) {
            $('#wrapper').css('margin-top', $('header').height() + 'px');
            $('#header, #totop').addClass("sticky");
        }
    } else {
        $('#header, #totop').removeClass("sticky");
        $('#wrapper').css('margin-top', '0px');
    }
});*/